import {BaseModel} from "../../../../../infrastructure/models/base-model";
import type {WebsiteModuleState} from "../../../../../apps/website/models/website-module.state";
import type {CompetitionDomainModel} from "../../../../../domain/common/competition/models/competition-domain-model";

export class CompetitionIndexPageDescriptionHeaderModel extends BaseModel {
  constructor(competition: CompetitionDomainModel, websiteModel: WebsiteModuleState) {
    super();

    this.competition = competition;
    this.websiteModel = websiteModel;
  }

  get title(): String {
    const title = (this.websiteModel.terms[`WEB_COMPETITION_MAIN_INPAGE_TITLE_${this.competition?.id}`] || this.websiteModel.terms[`WEB_COMPETITION_HP_INPAGE_TITLE_SPORTID_${this.competition.sport?.id}`] || this.websiteModel.terms.WEB_COMPETITION_HP_INPAGE_TITLE).format({
      "COMPETITION_NAME": this.competition?.longName || this.competition?.name,
      "LIVESCORE_MAIN_KEYWORD": this.websiteModel.terms.LIVESCORE_MAIN_KEYWORD,
    });

    return title;
  }

  get description(): String {
    const description: String = (this.websiteModel.terms[`WEB_COMPETITION_MAIN_INPAGE_DESCRIPTION_${this.competition?.id}`] || this.websiteModel.terms[`WEB_COMPETITION_HP_INPAGE_DESCRIPTION_SPORTID_${this.competition.sport?.id}`] || this.websiteModel.terms.WEB_COMPETITION_HP_INPAGE_DESCRIPTION).format({
      "COMPETITION_NAME": this.competition?.longName || this.competition?.name,
      "LIVESCORE_MAIN_KEYWORD": this.websiteModel.terms.LIVESCORE_MAIN_KEYWORD,
      "SEASON_YEAR": this.competition?.currentSeason?.name || '',
      "COMPETITION_CURRENT_YEAR": this.competition?.currentSeason?.name || ''
    });

    return description;
  }
}